import MailTop from '@views/mail/MailTop.vue'
import MailAuth from '@views/mail/MailAuth.vue'
import MailComplete from '@views/mail/MailComplete.vue'
export default [
  {
    path: '/user/mail',
    name: 'MailTop',
    component: MailTop,
    meta: {
      nav: 'back',
      title: 'メールアドレス変更',
      gaTitle: 'メールアドレス変更',
      footer: true
    }
  },
  {
    path: '/user/mail/auth',
    name: 'MailAuth',
    component: MailAuth,
    // props: (route) => ({
    //   codeRequestId: route.params.codeRequestId,
    //   email: route.query.email,
    //   useCase: route.query.use_case
    // }),
    meta: {
      nav: 'back',
      title: 'ご本人確認のお願い',
      gaTitle: 'ご本人確認のお願い',
      footer: true
    }
  },
  {
    path: '/user/mail/complete',
    name: 'MailComplete',
    component: MailComplete,
    // beforeEnter: (to, from, next) => {
    //   console.log('complete')
    //   if (from.name === 'MailAuth') {
    //     next()
    //   } else {
    //     // ここでいいのか確認
    //     next({ name: 'AshibetuTop' })
    //   }
    // },
    meta: {
      nav: 'none',
      title: 'メールアドレス変更',
      gaTitle: 'メールアドレス変更-完了',
      footer: true
    }
  }
]
